import arExperienceBackground from '../assets/arExperienceBackground.svg'

function ARExperience () {
    return (
        <div style={{backgroundImage: `url(${arExperienceBackground})`, backgroundSize: 'cover', height: '100vh', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center'}}>

        </div>
    )
}

export default ARExperience;